var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0775 6.74408C9.75206 7.06951 9.75206 7.59715 10.0775 7.92259L16.1549 14L10.0775 20.0774C9.75206 20.4028 9.75206 20.9305 10.0775 21.2559C10.4029 21.5814 10.9306 21.5814 11.256 21.2559L17.9227 14.5893C18.2481 14.2638 18.2481 13.7362 17.9227 13.4107L11.256 6.74408C10.9306 6.41864 10.4029 6.41864 10.0775 6.74408Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.4fc8c4c126b1e380eee8a80c6163cf2b.svg";
export { ForwardRef as ReactComponent };